<nz-select [nzMode]="multiple ? 'multiple' : 'default'" nzShowSearch nzServerSearch [nzPlaceHolder]="placeholder"
  [ngModel]="value" (ngModelChange)="onValueChange($event)" [nzShowArrow]="false" [nzFilterOption]="nzFilterOption"
  [nzSize]="size" [nzAllowClear]="true" [nzDisabled]="disabled" [nzNotFoundContent]="notFoundTemplate"
  [nzCustomTemplate]="selectedTemplate" (nzOnSearch)="onSearch($event)">
  <nz-option *ngFor="let item of emailList" [nzCustomContent]="true" [nzValue]="item.email" [nzLabel]="item.email">
    <div class="d-flex align-items-center justify-content-between">
      <span [class.text-danger]="item.dataInativo">
        {{ item.email }}<strong *ngIf="item.dataInativo" nz-tooltip
          [nzTooltipTitle]="item.justificativaInativacao"> - INATIVO</strong>
      </span>
      <button *ngIf="item.naoCadastrado" nz-button nzType="link" nzSize="small" title="Cadastrar novo e-mail"
        (mousedown)="$event.preventDefault(); $event.stopPropagation()" (click)="abrirCadastro(item.email, $event)">
        <span nz-icon nzType="plus"></span>
      </button>
      <ng-container *ngIf="item.id && !item.dataInativo">
        <button *ngxPermissionsOnly="['EMAIL_GRAVACAO']" nz-button nzType="text" nzSize="small"
          title="Inativar e-mail" (mousedown)="$event.preventDefault(); $event.stopPropagation()"
          (click)="inativarEmail(item, $event)">
          <span nz-icon nzType="stop"></span>
        </button>
      </ng-container>
    </div>
  </nz-option>
</nz-select>

<ng-template #selectedTemplate let-selected>
  <span [class.text-danger]="isInativo(selected.nzValue)" [class.fw-bold]="isInativo(selected.nzValue)">
    {{ selected.nzLabel }}<ng-container *ngIf="isInativo(selected.nzValue)"><span nz-tooltip
        [nzTooltipTitle]="findItem(selected.nzValue)?.justificativaInativacao"> - INATIVO</span></ng-container>
  </span>
</ng-template>

<ng-template #notFoundTemplate>
  <div class="d-flex align-items-center justify-content-between">
    <span>{{ buscaAtual.length >= 3 ? 'Email inexistente' : 'Digite ao menos 3 letras' }}</span>
    <button *ngIf="buscaAtual.length >= 3" nz-button nzType="link" nzSize="small" title="Cadastrar novo e-mail"
      (mousedown)="$event.preventDefault()" (click)="abrirCadastro()">
      <span nz-icon nzType="plus"></span>
    </button>
  </div>
</ng-template>
